<template>
    <div class="top-menu-bar-wrapper" :style="{ padding: $vuetify.breakpoint.lgAndUp ? '0 24px 0 24px' : '0 16px 0 16px' }">
        <UserInfoBlock :showSignOutBtn="$vuetify.breakpoint.lgAndUp" />
        <template v-if="$vuetify.breakpoint.lgAndUp">
            <v-tabs
                align-with-title
                active-class="active-tab"
            >
                <v-tabs-slider color="#DA251C"></v-tabs-slider>

                <v-tab :to="{ name: 'Station' }">
                    Ремонт авто
                </v-tab>
                <v-tab :to="{ name: 'History' }">
                    История ремонта
                </v-tab>
                <v-tab :to="{ name: 'Garage' }">
                    Мои авто
                </v-tab>
                <v-tab :to="{ name: 'StationAddress' }">
                    Адреса СТО
                </v-tab>
                <v-tab :to="{ name: 'Promo' }">
                    Акции
                </v-tab>
            </v-tabs>
            <v-spacer />
            <v-btn class="sign-up-btn" :to="{ name: 'StationOnlineOrder' }">
                Записаться
            </v-btn>
        </template>
    </div>
</template>

<script>
    import UserInfoBlock from '@/components/Vuetify/UserInfoBlock'

    export default {
        name: 'TopMenuBar',

        components: {
            UserInfoBlock,
        },
    }
</script>

<style>
    .top-menu-bar-wrapper {
        margin: 16px 0 16px 0;
        border-radius: 10px;
        background: #FFF;
        display: flex;
        align-items: center;
        max-width: 1280px;
        width: 100%;
        height: 84px;
    }
    .top-menu-bar-wrapper .v-tab {
        text-transform: none !important;
    }
    .top-menu-bar-wrapper .v-tab {
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: normal;
    }
    .top-menu-bar-wrapper .active-tab {
        color: #DA251C;
    }
    .top-menu-bar-wrapper .sign-up-btn {
        width: 178px;
        height: 52px !important;
        padding: 16px 40px !important;
        border-radius: 10px;
        border: 2px solid #DA251C;
        background: #DA251C !important;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
</style>
